<template>
  <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
    <modal
      :show.sync="show"
      modal-classes="modal-secondary"
      @close="$emit('close')"
    >
      <div slot="header" class="text-center">
        <h2 class="text-uppercase text-center">Edit Information</h2>
      </div>
      <form class="new-event--form" @submit.prevent="handleSubmit(submitForm)">
        <base-input
          label="Full Name"
          name="name"
          rules="required"
          type="text"
          v-model="affiliate.name"
        ></base-input>
        <base-input
          label="Address"
          name="address"
          :rules="{ required: true }"
          type="text"
          placeholder="246 West Broadway, New York"
          v-model="affiliate.address.address"
        ></base-input>
        <base-input
          label="Country"
          rules="required"
          name="country"
          type="text"
          v-model="affiliate.address.country"
        ></base-input>
        <base-input label="Payment Type" name="payment type" rules="required">
          <el-select
            v-model="affiliate.paymentInfo.type"
            rules="required"
            default-first-option
            placeholder="Select a payment method"
          >
            <el-option
              v-for="option in paymentOptions"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            >
            </el-option>
          </el-select>
        </base-input>
        <base-input
          v-if="affiliate.paymentInfo.type === 'paypal'"
          label="PayPal Email"
          :rules="{ required: true, email: true }"
          name="paypal email"
          type="text"
          v-model="affiliate.paymentInfo.paypal"
        ></base-input>
        <base-input
          v-if="affiliate.paymentInfo.type === 'ach'"
          label="ACH Details"
          :rules="{ required: true }"
          name="payment details"
        >
          <textarea
            class="form-control"
            v-model="affiliate.paymentInfo.ach"
            id="achDetails"
            rows="5"
            :placeholder="`Bank Name:\nAccount Name:\nAccount Number:\nRouting Number:`"
          ></textarea>
        </base-input>
      </form>
      <template slot="footer">
        <base-button
          type="submit"
          class="btn btn-primary new-event--add"
          :loading="loading"
          @click="handleSubmit(submitForm)"
          >Save Information
        </base-button>
        <button
          type="button"
          class="btn btn-link ml-auto"
          @click="$emit('close')"
        >
          Close
        </button>
      </template>
    </modal>
  </validation-observer>
</template>

<script>
import { Select, Option } from 'element-ui'

export default {
  name: 'AffiliateInformationModal',
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    affiliateInfo: Object,
    show: Boolean,
    loading: {
      type: Boolean,
      defaultsTo: false
    }
  },
  data() {
    return {
      affiliate: { address: {}, paymentInfo: {} },
      paymentOptions: [
        { id: 'paypal', name: 'PayPal' },
        { id: 'ach', name: 'US Bank Account (ACH)' }
      ]
    }
  },
  methods: {
    submitForm() {
      this.$emit('submit', this.affiliate)
    }
  },
  watch: {
    show() {
      this.affiliate = JSON.parse(
        JSON.stringify({ address: {}, paymentInfo: {}, ...this.affiliateInfo })
      )
    }
  }
}
</script>

<style scoped></style>
